export const moveButtons = (event, scrolling) => {
    if (scrolling) {
        const currentX = scrolling.getCurrentTranslateX();
        const trackWidth = scrolling.getTrackWidth();
        const offsetLeft = event.target.offsetLeft;
        const buttonWidth = event.target.clientWidth;

        // доля видимой следующей кнопки (чтобы при прокручивании при выборе кнопке было видно и кусочек следующей кнопки)
        const nextButtonOffset = 0.6 * buttonWidth;

        // сдвиг вправо при нажатии крайней правой видимой кнопки
        // transform = *ширина видимой области* - *offset правого края кнопки* - *доля видимой справа следующей кнопки*
        let transform = trackWidth - (offsetLeft + buttonWidth) - nextButtonOffset;
        if (transform < currentX) {
            scrolling.transform(transform + 'px');
        } else {
            // сдвиг влево при нажатии крайней левой видимой кнопки
            // transform = *offset левого края кнопки* + *доля видимой слева следующей кнопки*
            transform = -offsetLeft + nextButtonOffset;
            if (offsetLeft - nextButtonOffset < Math.abs(currentX)) {
                scrolling.transform(transform + 'px');
            }
        }
    }
};
